export default __webpack_public_path__ + "static/media/google-play-badge.3263f5e2.svg";